<template>
  <div>
    <DataTable
      :value="typefieldconfigurationData"
      :expandedRows.sync="expandedRows"
      :loading="loading"
      data-key="name"
      :paginator="true"
      :rows="10"
      :filters="filters"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    >
      <template #header>
        <div class="table-header-container">
          Type Field Configuration
          <!-- <Button icon="pi pi-plus" label="Expand All" @click="expandAll" class="p-mr-2" />
          <Button icon="pi pi-minus" label="Collapse All" @click="collapseAll" /> -->
        </div>
      </template>
      <template #empty>
        <strong class="text-center">No Records found.</strong>
      </template>
      <Column :expander="true" headerStyle="width: 3rem" />
      <Column
        field="name"
        header="Name"
        v-model="filters['name']"
        sortable
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['name']"
            class="p-column-filter"
            placeholder="Contains"
          />
        </template>
      </Column>
      <Column
        field="hasDeleted"
        header="Has Deleted"
        filterMatchMode="custom"
        :filterFunction="filterStatus"
        sortable
      >
        <template #body="slotProps">{{
          formatStatus(slotProps.data.hasDeleted)
        }}</template>
        <template #filter>
          <Dropdown
            v-model="filters['hasDeleted']"
            :options="statuses"
            placeholder="Select"
            class="p-column-filter"
            :showClear="true"
          >
            <template #option="slotProps">
              <span>{{ slotProps.option }}</span>
            </template>
          </Dropdown>
        </template>
      </Column>
      <Column
        field="dataUrl"
        header="Data Url"
        v-model="filters['dataUrl']"
        sortable
        filterMatchMode="contains"
        headerStyle="width:40rem"
      >
        <template #body="slotProps"
          ><a style="word-wrap: break-word;">{{
            slotProps.data.dataUrl
          }}</a></template
        >
        <template #filter>
          <InputText
            type="text"
            v-model="filters['dataUrl']"
            class="p-column-filter"
            placeholder="Contains"
          />
        </template>
      </Column>
      <Column headerStyle="width:10rem">
        <template #body="slotProps">
          <Button
            icon="pi pi-eye"
            v-tooltip.top="'View Response Properties'"
            class="p-button-primary p-button-rounded p-mr-2"
            @click="openResponseProperties(slotProps.data.responseProperties)"
          />
          <!-- <span
            v-tooltip.top="'View Response Properties'"
            class="p-button-primary p-button-rounded p-mr-2 p-button p-component p-button-icon-only "
            @click="openResponseProperties(slotProps.data.responseProperties)"
            ><font-awesome-icon icon="user-secret"
          /></span> -->
          <Button
            icon="pi pi-plus"
            v-tooltip.top="'Add Field'"
            class="p-button-rounded p-button-success p-mr-2"
            @click="addTypefields(slotProps, 'add')"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <div class>
          <DataTable :value="slotProps.data.fields" :filters="fieldfilters">
            <template #empty>
              <strong class="text-center">No Records found.</strong>
            </template>
            <Column
              field="sourceFieldCode"
              header="Source Field Code"
              v-model="fieldfilters['sourceFieldCode']"
              sortable
              filterMatchMode="contains"
            >
              <template #filter>
                <InputText
                  type="text"
                  v-model="fieldfilters['sourceFieldCode']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
              <template #body="slotProps"
                ><span style="word-wrap: break-word;">{{
                  slotProps.data.sourceFieldCode
                }}</span></template
              >
            </Column>
            <Column
              field="destinationFieldName"
              header="Destination Field Name"
              v-model="fieldfilters['destinationFieldName']"
              sortable
              filterMatchMode="contains"
            >
              <template #filter>
                <InputText
                  type="text"
                  v-model="fieldfilters['destinationFieldName']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column
              field="displayName"
              header="Display Name"
              v-model="fieldfilters['displayName']"
              sortable
              filterMatchMode="contains"
            >
              <template #filter>
                <InputText
                  type="text"
                  v-model="fieldfilters['displayName']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column
              field="type"
              header="Type"
              v-model="fieldfilters['type']"
              sortable
              filterMatchMode="contains"
            >
              <template #filter>
                <InputText
                  type="text"
                  v-model="fieldfilters['type']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column
              field="isCustomField"
              header="Is Custom Field"
              filterMatchMode="custom"
              :filterFunction="filterStatus"
              sortable
            >
              <template #body="slotProps">{{
                formatStatus(slotProps.data.isCustomField)
              }}</template>
              <template #filter>
                <Dropdown
                  v-model="fieldfilters['isCustomField']"
                  :options="statuses"
                  placeholder="Select"
                  class="p-column-filter"
                  :showClear="true"
                >
                  <template #option="slotProps">
                    <span>{{ slotProps.option }}</span>
                  </template>
                </Dropdown>
              </template>
            </Column>
            <Column
              field="relResponseProperty"
              v-model="fieldfilters['relResponseProperty']"
              sortable
              filterMatchMode="contains"
              title="'View Stats'"
            >
              <template #header>
                <span class="table-header-container">
                  Rel Response Property
                </span>
                <i
                  class="pi pi-info-circle info"
                  v-tooltip.top="'Sample Text'"
                ></i>
              </template>
              <template #filter>
                <InputText
                  type="text"
                  v-model="fieldfilters['relResponseProperty']"
                  class="p-column-filter"
                  placeholder="Contains"
                />
              </template>
            </Column>
            <Column headerStyle="width:10rem">
              <template #body="slotProps">
                <Button
                  icon="pi pi-pencil"
                  v-tooltip.top="'Edit Field'"
                  class="p-button-warning p-button-rounded p-mr-2"
                  @click="editTypeFields(slotProps.data, 'edit')"
                />
              </template>
            </Column>
            <!-- <template #filter>
           <span> {{slotProps.data.id}}</span>
              </template>-->
          </DataTable>
        </div>
      </template>
    </DataTable>
    <Dialog
      header="Response Properties"
      maximizable
      :visible.sync="responsePropertiesDialog"
      :style="{ width: '80vw' }"
      :modal="true"
    >
      <DataTable
        :value="ResponseProperties"
        :expandedRows.sync="expandedRows"
        :loading="loading"
        data-key="name"
        :paginator="true"
        :rows="5"
        :filters="responsefilters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25, 50]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      >
        <!-- <template #header>
        <div class="table-header-container">
          <Button icon="pi pi-plus" label="Expand All" @click="expandAll" class="p-mr-2" />
          <Button icon="pi pi-minus" label="Collapse All" @click="collapseAll" />
        </div>
        </template>-->
        <template #empty>
          <strong class="text-center">No Records found.</strong>
        </template>
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column
          field="name"
          header="Name"
          v-model="responsefilters['name']"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="name"
              v-model="responsefilters['name']"
              class="p-column-filter"
              placeholder="Contains"
            />
          </template>
        </Column>
        <Column
          field="order"
          header="Order"
          v-model="responsefilters['order']"
          sortable
        >
          <template #filter>
            <InputText
              type="order"
              v-model="responsefilters['order']"
              class="p-column-filter"
              placeholder="Equals"
            />
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class>
            <DataTable
              :value="slotProps.data.fields"
              :filters="responsechildfilters"
            >
              <template #empty>
                <strong class="text-center">No Records found.</strong>
              </template>
              <!-- <Column :expander="true" headerStyle="width: 3rem" /> -->
              <Column
                field="sourceFieldCode"
                header="Source Field Code"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="responsechildfilters['sourceFieldCode']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column
                field="displayName"
                header="Display Name"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="responsechildfilters['displayName']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column
                field="destinationFieldName"
                header="Destination Field Name"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="responsechildfilters['destinationFieldName']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column
                field="isCustomField"
                header="Is Custom Field"
                filterMatchMode="custom"
                :filterFunction="filterStatus"
                sortable
                headerStyle="width: 11rem"
              >
                <template #body="slotProps">{{
                  formatStatus(slotProps.data.isCustomField)
                }}</template>
                <template #filter>
                  <Dropdown
                    v-model="responsechildfilters['isCustomField']"
                    :options="statuses"
                    placeholder="Select"
                    class="p-column-filter"
                    :showClear="true"
                  >
                    <template #option="slotProps">
                      <span>{{ slotProps.option }}</span>
                    </template>
                  </Dropdown>
                </template>
              </Column>
              <Column
                field="type"
                header="Type"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="responsechildfilters['type']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
              <Column
                field="relResponseProperty"
                header="Rel Response Property"
                filterMatchMode="contains"
                sortable
              >
                <template #filter>
                  <InputText
                    type="text"
                    v-model="responsechildfilters['relResponseProperty']"
                    class="p-column-filter"
                    placeholder="Contains"
                  />
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
      <template #footer>
        <Button
          label="Close"
          icon="pi pi-times"
          @click="responsePropertiesDialog = false"
          class="p-button-rounded p-button-danger"
        />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="editTypeFieldsDialog"
      :style="{ width: '50vw' }"
      :modal="true"
      class="p-fluid"
      :contentStyle="{overflow: 'visible'}"
    >
      <template #header>
        <span class="modalheader">
          <span class="p-text-capitalize">{{ fieldmaintype }}</span>
          <span>&nbsp;{{ typeFields.displayName }}</span
          >
        </span>
      </template>
      <div class="p-field">
        <label for="sourceFieldCode">Source Field Code<span class="text-red">*</span></label>
        <InputText
          id="sourceFieldCode"
          v-model="sourceFieldCode"
          required="true"
          :class="{ 'p-invalid': submitted && !sourceFieldCode }"
        />
        <small class="p-invalid" v-if="submitted && !sourceFieldCode"
          >Source Field Code is required.</small
        >
      </div>
      <div class="p-field">
        <label for="sourceFieldCode">Destination Field Name<span class="text-red">*</span></label>
        <InputText
          id="destinationFieldName"
          v-model="destinationFieldName"
          required="true"
          :class="{
            'p-invalid': submitted && !destinationFieldName,
          }"
        />
        <small class="p-invalid" v-if="submitted && !destinationFieldName"
          >Destination Field Name is required.</small
        >
      </div>
      <div class="p-field">
        <label for="displayName">Display Name<span class="text-red">*</span></label>
        <InputText
          id="displayName"
          v-model="displayName"
          required="true"
          :class="{ 'p-invalid': submitted && !displayName }"
        />
        <small class="p-invalid" v-if="submitted && !displayName"
          >Display Name is required.</small
        >
      </div>
      <div class="p-field">
        <label for="types">Type<span class="text-red">*</span></label>
        <Dropdown
          v-model="selectedtype"
          :options="types"
          optionLabel="name"
          optionValue="name"
          placeholder="Select a type"
          :class="{ 'p-invalid': submitted && !selectedtype }"
          :filter="true"
        />
        <small class="p-invalid" v-if="submitted && !selectedtype"
          >Type is required.</small
        >
      </div>
      <div class="p-field" v-if="selectedtype == 'Rel'">
        <label for="RelResponsePropertyList">Rel Response Property<span class="text-red">*</span></label>
        <Dropdown
          v-model="selectedResponseProperty"
          :options="RelResponsePropertyList"
          placeholder="Select"
          :class="{
            'p-invalid':
              submitted && !selectedResponseProperty && selectedtype == 'Rel',
          }"
        >
        </Dropdown>
        <small
          class="p-invalid"
          v-if="submitted && !selectedResponseProperty && selectedtype == 'Rel'"
          >Rel Response is required.</small
        >
      </div>
      <div class="p-field">
        <label for="selectedcustomtype">Is Custom Field<span class="text-red">*</span></label>
        <Dropdown
          v-model="selectedcustomtype"
          :options="statuses"
          placeholder="Select"
          :class="{ 'p-invalid': submitted && !selectedcustomtype }"
        >
        </Dropdown>
        <small class="p-invalid" v-if="submitted && !selectedcustomtype"
          >Is Custom Field is required.</small
        >
      </div>

      <template #footer>
        <Button
          label="Save"
          icon="pi pi-check"
          @click="saveTypeFields()"
          class="p-button-rounded p-button-primary"
        />
        <Button
          label="Cancel"
          @click="
            editTypeFieldsDialog = false;
            cancelEditTypeFields();
          "
          icon="pi pi-times"
          class="p-button-rounded p-button-danger"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
export default {
  data() {
    return {
      selectedtype: null,
      selectedcustomtype: null,
      selectedResponseProperty: null,
      filters: {},
      fieldfilters: {},
      statuses: ['Yes', 'No'],
      typefieldconfigurationData: null,
      expandedRows: [],
      responsefilters: {},
      responsechildfilters: {},
      responsePropertiesDialog: false,
      ResponseProperties: [],
      editTypeFieldsDialog: false,
      typeFields: {},
      typeFieldsEditInputs: {},
      types: [],
      RelResponsePropertyList: [],
      editedObj: {},
      itemsBeforeEdit: null,
      submitted: false,
      sourceFieldCode: null,
      destinationFieldName: null,
      displayName: null,
      fieldmaintype: null,
    };
  },
  created() {
    this.loading = true;
    let that = this;
    this.gettypefields();
    let input = {
      Type: 'FieldType',
    };
    this.$store
      .dispatch('masterdata/getMasterData', input)
      .then(() => {
        that.types = this.$store.getters['masterdata/getMasterDataResult'];
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted() {},
  methods: {
    gettypefields: function () {
      this.$store
        .dispatch('typefieldconfig/getTypeFieldConfigData')
        .then(() => {
          this.typefieldconfigurationData = this.$store.getters[
            'typefieldconfig/getTypeFieldConfigurationResult'
          ];
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openResponseProperties(data) {
      this.responsefilters = {};
      this.responsechildfilters = {};
      this.responsePropertiesDialog = true;
      this.ResponseProperties = data;
    },
    // onRowExpand() {
    //   this.fieldfilters={}
    // },
    // onRowCollapse(event) {
    //   this.$toast.add({
    //     severity: 'success',
    //     summary: 'Product Collapsed',
    //     detail: event.data.name,
    //     life: 3000,
    //   });
    // },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    formatStatus(value) {
      return value == true ? 'Yes' : 'No';
    },
    filterDate(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === 'string' && filter.trim() === '')
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      value = moment(value).format('YYYY-MM-DD');
      filter = moment(filter).format('YYYY-MM-DD');
      return value === filter;
    },
    filterStatus(value, filter) {
      if (
        filter === undefined ||
        filter === null ||
        (typeof filter === 'string' && filter.trim() === '')
      ) {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }
      value = value == true ? 'Yes' : 'No';
      return value === filter;
    },
    upsertTypeFields: function (input,text) {
      this.$store
        .dispatch('typefieldconfig/upsertTypeFieldConfiguration', input)
        .then(() => {
          this.editTypeFieldsDialog = false;
          this.$toast.add({
            severity: 'success',
            summary: 'Successful',
            detail: text =='add' ? 'New Field Added' : 'Field Updated',
            life: 3000,
          });
          this.fieldmaintype = null;
          this.gettypefields();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addTypefields(item, text) {
      this.RelResponsePropertyList = [];
      this.submitted = false;
      this.editTypeFieldsDialog = true;
      this.fieldmaintype = text;
      (this.selectedtype = null),
        (this.selectedcustomtype = null),
        (this.selectedResponseProperty = null),
        (this.sourceFieldCode = null),
        (this.destinationFieldName = null),
        (this.displayName = null),
        (this.typeFields = {});
      this.typefieldconfigurationData.forEach((element) => {
        if (element.id == item.data.id) {
          element.responseProperties.forEach((elem) => {
            this.RelResponsePropertyList.push(elem.name);
          });
          this.editedObj = element;
        }
      });
    },
    editTypeFields(item, text) {
      this.submitted = false;
      this.fieldmaintype = text;
      this.itemsBeforeEdit = _.cloneDeep(item);
      this.typeFields = item;
      this.RelResponsePropertyList = [];
      this.editTypeFieldsDialog = true;
      this.selectedtype = item.type;
      this.selectedcustomtype = item.isCustomField ? 'Yes' : 'No';
      this.selectedResponseProperty = item.relResponseProperty;
      this.sourceFieldCode = item.sourceFieldCode;
      this.destinationFieldName = item.destinationFieldName;
      this.displayName = item.displayName;

      this.typefieldconfigurationData.forEach((element) => {
        if (element.id == item.typeFieldConfigId) {
          element.responseProperties.forEach((elem) => {
            this.RelResponsePropertyList.push(elem.name);
          });
          this.editedObj = element;
        }
      });
    },
    saveTypeFields() {
      this.submitted = true;
      if (
        this.sourceFieldCode &&
        (this.selectedtype.trim() == 'Rel'
          ? this.selectedResponseProperty
          : true) &&
        this.destinationFieldName &&
        this.displayName &&
        this.selectedtype &&
        this.selectedcustomtype
      ) {
        this.typeFields.type = this.selectedtype;
        this.typeFields.isCustomField =
          this.selectedcustomtype == 'Yes' ? true : false;
        this.typeFields.relResponseProperty = this.selectedResponseProperty;
        this.typeFields.sourceFieldCode = this.sourceFieldCode;
        this.typeFields.destinationFieldName = this.destinationFieldName;
        this.typeFields.displayName = this.displayName;
        if (this.fieldmaintype == 'add') {
          this.editedObj.fields.push(this.typeFields);
        }
        this.upsertTypeFields(this.editedObj,this.fieldmaintype);
      }
    },
    cancelEditTypeFields() {
      this.submitted = false;
      if(this.fieldmaintype =="edit"){
        this.typeFields.sourceFieldCode = this.itemsBeforeEdit.sourceFieldCode;
        this.typeFields.destinationFieldName = this.itemsBeforeEdit.destinationFieldName;
        this.typeFields.displayName = this.itemsBeforeEdit.displayName;
        this.typeFields.type = this.itemsBeforeEdit.type;
        this.typeFields.isCustomField = this.itemsBeforeEdit.isCustomField;
        this.typeFields.relResponseProperty = this.itemsBeforeEdit.relResponseProperty;
      }
    },
  },
};
</script>


